import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation
} from '@angular/core';

@Component({
  selector: 'cs-select-check-box',
  standalone: false,
  templateUrl: './select-check-box.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./select-check-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  // tslint:disable-next-line: no-host-metadata-property
  host: {
    class: 'cs-selected-check-box',
    '[class.cs-selected-check-box-checked]': '_state === "checked"'
  }
})
export class SelectCheckBoxComponent {
  @Input()
  public set state(val: boolean | 'unchecked' | 'checked') {
    this._state =
      typeof val === 'boolean' ? (val ? 'checked' : 'unchecked') : val;
  }
  public _state: 'unchecked' | 'checked';
}
